import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

export enum MoveButtonDirection {
  Up = 'up',
  Down = 'down',
}

interface MoveButtonsProps {
  updateHandler: (direction: MoveButtonDirection) => void;
  show?: boolean,
  hideUp?: boolean,
  hideDown?: boolean,
}

function MoveButtons({
  updateHandler, show = true, hideUp, hideDown,
}: MoveButtonsProps) {
  return (
    <Box
      sx={{
        display: show ? 'flex' : 'none',
        justifyContent: 'end',
        alignItems: 'center',
        right: 20,
        top: -10,
        position: 'absolute',
        zIndex: 1,
        width: 50,
        height: 20,
      }}
    >
      {!hideUp && (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: '#BFBFBF8A',
            fontSize: 14,
            width: 20,
            minWidth: 20,
            height: 20,
            minHeight: 20,
          }}
          onClick={(event) => {
            updateHandler(MoveButtonDirection.Up);
            event.stopPropagation();
          }}
        >
          <ArrowUpward fontSize="small" />
        </Button>
      )}
      {!hideDown && (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: '#BFBFBF8A',
            fontSize: 14,
            width: 20,
            minWidth: 20,
            height: 20,
            minHeight: 20,
            marginLeft: '10px',
          }}
          onClick={(event) => {
            updateHandler(MoveButtonDirection.Down);
            event.stopPropagation();
          }}
        >
          <ArrowDownward fontSize="small" />
        </Button>
      )}
    </Box>
  );
}

export default MoveButtons;
